import React, { useEffect, useRef, useState } from 'react';
import { jobNumber, jobName } from '../utils/ui';

// Mobile-friendly type-to-search job picker. `projects` is the list to search,
// `value` is the selected project id, `onChange(id)` fires on pick. Big touch
// targets and 16px inputs (no iOS zoom).
export default function JobSearchSelect({ value, projects = [], onChange, placeholder = 'Search jobs…' }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const ref = useRef(null);
  useEffect(() => {
    function onDoc(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);
  const selected = projects.find(p => p.id === value);
  const label = p => `${jobNumber(p) ? jobNumber(p) + ' · ' : ''}${jobName(p)}`.trim();
  const ql = q.trim().toLowerCase();
  const list = projects.filter(p => !ql || label(p).toLowerCase().includes(ql)).slice(0, 40);
  const inp = { width: '100%', boxSizing: 'border-box', padding: '12px 14px', borderRadius: 10, border: '1.5px solid #ddd', fontSize: 16, color: '#111', background: '#fff' };
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <input
        value={open ? q : (selected ? label(selected) : '')}
        onChange={e => { setQ(e.target.value); if (!open) setOpen(true); }}
        onFocus={() => { setOpen(true); setQ(''); }}
        placeholder={selected ? label(selected) : placeholder}
        style={inp} />
      {open && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 50, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, marginTop: 4, maxHeight: 260, overflowY: 'auto', boxShadow: '0 10px 30px rgba(0,0,0,0.18)' }}>
          {list.length === 0 && <div style={{ padding: '12px 14px', fontSize: 14, color: '#9ca3af' }}>No jobs found</div>}
          {list.map(p => (
            <div key={p.id} onMouseDown={() => { onChange(p.id); setOpen(false); setQ(''); }}
              style={{ padding: '12px 14px', fontSize: 15, cursor: 'pointer', borderBottom: '1px solid #f3f4f6', background: p.id === value ? '#fff7ed' : '#fff', color: '#111' }}>
              {jobNumber(p) && <span style={{ fontWeight: 700, color: '#e87722' }}>{jobNumber(p)} · </span>}{jobName(p)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
